import axios from "axios";
import { create } from "zustand";

const searchTagStore = create((set) => ({
  searchTags: null,

  _id: null,
  tag: "",

  writeData: ({ name, value }) => {
    set({ [name]: value });
  },

  clearData: () => {
    set({ _id: null, tag: "" });
  },

  createSearchTag: async () => {
    const { tag, searchTags, clearData } = searchTagStore.getState();

    // Create search tag
    const res = await axios.post("/create-search-tag", { tag });

    // set store
    const data = searchTags ? [...searchTags] : [];
    data.push(res.data.searchTag);
    set({ searchTags: data });

    // clear data in input
    clearData();
  },

  fetchAllSearchTag: async () => {
    // fetch search tags
    const res = await axios.get("/fetch-all-search-tag");
    // set tags to state
    set({ searchTags: res.data.searchTags });
  },

  updateSearchTagStatus: async ({ _id, status }) => {
    try {
      const { searchTags } = searchTagStore.getState();
      // Send the update request
      const res = await axios.put(`/update-search-tag-status/${_id}`, {
        status,
      });

      // update state
      const newSearchTags = [...searchTags];
      const indexSearchTag = searchTags.findIndex((s) => {
        return s._id === _id;
      });
      newSearchTags[indexSearchTag] = res.data.searchTag;

      set({ searchTags: newSearchTags });
    } catch (error) {
      console.log(error);
    }
  },

  fillUpdateData: ({ _id, tag }) => {
    set({ _id: _id, tag: tag });
  },

  updateSearchTag: async () => {
    try {
      const { _id, tag } = searchTagStore.getState();
      const { searchTags } = searchTagStore.getState();
      // Send the update request
      const res = await axios.put(`/update-search-tag/${_id}`, {
        tag,
      });

      // update state
      const newSearchTags = [...searchTags];
      const indexSearchTag = searchTags.findIndex((s) => {
        return s._id === _id;
      });
      newSearchTags[indexSearchTag] = res.data.searchTag;

      set({ searchTags: newSearchTags });
    } catch (error) {
      console.log(error);
    }
  },
}));

export default searchTagStore;
